'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import type { BrandProps } from 'src/components/Organisms/Brand';
import { Brand } from 'src/components/Organisms/Brand';
import { styled } from '@mui/material/styles';
import { FlexColumn } from 'src/components/Atoms/FlexBox';
const ContentWrapper = styled(FlexColumn)<{
  background?: string;
}>(({
  theme,
  background
}) => ({
  padding: theme.sizes.spacing['12'],
  justifyContent: 'flex-end',
  alignItems: 'flex-start',
  gap: theme.sizes.spacing['06'],
  display: 'inline-flex',
  backgroundImage: `url(${background})`,
  backgroundSize: 'cover',
  background: 'linear-gradient(\'0deg\', rgba(0, 0, 0, 0.60) \'0%\', rgba(0, 0, 0, 0.60) \'100%\')',
  overflow: 'hidden',
  borderRadius: theme.sizes.radius.sm,
  width: '50%',
  height: '100%'
}));
const StyledBrand = styled(Brand)<BrandProps>(({
  theme
}) => ({
  position: 'absolute',
  display: 'block',
  zIndex: theme.zIndex.drawer + 1,
  top: theme.sizes.spacing['10'],
  right: theme.sizes.spacing['08']
}));
interface ContentPanelProps {
  backgroundImage?: string;
  children?: React.ReactNode;
}
const ContentPanel: React.FC<ContentPanelProps> = t0 => {
  const $ = _c(4);
  const {
    backgroundImage,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <StyledBrand small={false} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = children || null;
  let t3;
  if ($[1] !== backgroundImage || $[2] !== t2) {
    t3 = <ContentWrapper background={backgroundImage}>{t1}{t2}</ContentWrapper>;
    $[1] = backgroundImage;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default ContentPanel;